import { UIButton } from '../../shared/UIButton.styles';
import { styled } from '@mui/material/styles';

export const SkipToMainContentButtonContainer = styled(UIButton)(({ theme }) => ({
  position: 'absolute',
  height: '0px',
  top: '0px',
  width: '0px',
  overflow: 'hidden',
  zIndex: 222147483645,
  padding: '0px 50px',
  border: 'none !important',
  '&:focus-within': {
    position: 'absolute',
    left: '0px',
    top: '0px',
    width: 'auto',
    height: '68px',
  },
  '&:focus-visible': {
    outline: 'none',
    outlineOffset: '0',
    visibility: 'hidden',
  },
  [theme.breakpoints.down('sm')]: {
    '&:focus-within': {
      width: 'calc(100vw - 1rem)',
    },
    '&:focus': {
      width: 'calc(100vw - 1rem)',
    },
  },
}));
